import React from "react";

import "./Blog.css";

import FoundersGuideHeader from "../components/FoundersGuideHeader";
import BlogsOverview from "../components/BlogsOverview";
import Nav from "../components/Nav";
import {meta} from "../assets/meta/meta";
import {CustomMetaHelmet} from "../components/CustomMetaHelmet";

function Blog() {
    return (
        <div className="Blog">
            <CustomMetaHelmet meta={meta.blog}/>
            <Nav/>
            <FoundersGuideHeader/>
            <section className="blogs-overview-container">
                <h1>How to guides</h1>
                <BlogsOverview/>
            </section>
            {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 1280 96"
                fill="none"
            >
                <path d="M1280 0V96H640H0L1280 0Z" fill="#F3F4F6" />
            </svg>
            <section className="content-type-section">
                <section className="content-type-container">
                    <div className="content-type-container-header">
                        <h1>Other content type</h1>
                    </div>
                    <ContentType />
                </section>
            </section>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 1280 96"
                fill="none"
            >
                <path d="M1280 96V0H640H0L1280 96Z" fill="#F3F4F6" />
            </svg> */}
        </div>
    );
}

export default Blog;
